export const Arrow = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 22 8" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.58579 6.83579C10.3668 7.61684 11.6332 7.61683 12.4142 6.83579L18.0784 1.17157C18.8286 0.421426 19.846 -9.53674e-07 20.9069 -9.53674e-07H22H0H1.09315C2.15401 -9.53674e-07 3.17143 0.421427 3.92157 1.17157L9.58579 6.83579Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
